module.exports = __webpack_public_path__ + "img/mn.5e4a6131.svg";